<template>
    <base-input label="Voicemail">
        <el-autocomplete
            v-if="hasVoicemails"
            style="display:block;"
            v-model="voicemail"
            :fetch-suggestions="querySearch"
            placeholder="Search voicemails"
            :clearable="true"
            @clear="handleClear"
            @select="handleSelect"
        >
            <template slot-scope="{ item }">
                <span v-if="item.label != null">{{ item.label }} <span>( {{ item.value }} )</span></span>
                <span v-if="item.label == null">{{ item.name }}</span>
            </template>
        </el-autocomplete>
        <small v-if="hasVoicemails" slot="helperText" id="nameHelp" class="form-text text-muted">
            <!--This voicemail box will be used if not other has been manually selected in any of the destinations-->
        </small>
        <span v-if="!hasVoicemails">You have no voicemails, you can create one <router-link
            to="/voicemails">here</router-link></span>
    </base-input>
</template>

<script>
    import {mapFields} from "vuex-map-fields";

    export default {
        name: "VoicemailSelector",
        props: {
            initialVoicemail: {
                type: String,
                default: '',
            },
        },
        computed: {
            ...mapFields('voicemail', ['voicemails']),
            hasVoicemails: function () {
                if (this.$store.getters['voicemail/isLoading']) {
                    return true;
                }
                return this.voicemails.length > 0;
            },
        },
        data() {
            return {
                voicemail: this.initialVoicemail,
            }
        },
        methods: {
            querySearch(queryString, cb) {
                let voicemails = this.voicemails;
                let results = queryString ? voicemails.filter(this.createFilter(queryString)).map(s => {
                    return {name: s.name, value: s.name, label: s.label}
                }) : voicemails.map(s => {
                    return {name: s.name, value: s.name, label: s.label}
                });
                cb(results);
            },
            createFilter(queryString) {
                return (voicemail) => {
                    let label = voicemail.label || '';
                    let name = voicemail.name || '';
                    let value = voicemail.value || '';

                    let nameExists = label.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
                    return (nameExists);
                };
            },
            handleSelect(voicemail) {
                let name = voicemail.name;
                this.$emit('update', {name});
            },
            handleClear() {
                let name = null;
                this.$emit('update', {name});
            }
        },
        mounted() {
            if (this.$store.getters['voicemail/needUpdate']) {
                this.$store.dispatch('voicemail/loadVoicemails');
            }
        },
        watch: {
            // whenever question changes, this function will run
            initialVoicemail: function (newVoicemail, oldVoicemail) {
                this.voicemail = newVoicemail;
            }
        },
    }
</script>

<style scoped>

</style>
